import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { AlertsService } from '@app/core/services';
import { CustomerService } from '@app/data/amn-api/services';
import { AmnFilesUploadComponent } from '@app/shared/components';
import { PrimeNgModule } from '@app/shared/primeng/primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { Subscription, first } from 'rxjs';

@Component({
  selector: 'app-customer-document-upload',
  standalone: true,
  imports: [
    PrimeNgModule,
    SharedModule,
    TranslateModule,
    CommonModule,
    AmnFilesUploadComponent
  ],
  templateUrl: './customer-document-upload.component.html',
  styleUrl: './customer-document-upload.component.scss'
})
export class CustomerDocumentUploadComponent {
  @Input() customerId: number = 0;
  @Output() documentsUploaded = new EventEmitter<void>();

  customerSubscription: Subscription = new Subscription();

  @ViewChild('amnFilesUploader') fileUploader!: AmnFilesUploadComponent;

  constructor(
    private customerService: CustomerService,
    private alertsService: AlertsService
  ) {}

  onUpload(files: Blob[]) {
    if (files && files.length > 0) {
      this.customerService
        .uploadCustomerDocumentAsync({ id: this.customerId, body: { files } })
        .pipe(first())
        .subscribe({
          next: () => {
            this.alertsService.addSuccess(
              'Alerts.DocumentsUploaded',
              'Alerts.CustomerDocumentsUploadedSuccessfully',
              true
            );
            this.documentsUploaded.emit();
            this.fileUploader.clearFileUpload();
          },
          error: () => {
            this.alertsService.addWarning(
              'Alerts.ErrorUploadingDocuments',
              'Alerts.ErrorUploadingDocumentsDesc',
              true
            );
          }
        });
    }
  }
}
